import { Injectable } from "@angular/core";
import { HttpBackend, HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { MedicareConfig } from "@core/interfaces/api-responses/medicare-config";
import { FeatureFlag } from "@core/interfaces/entities/feature-flag";
import { AutoCompleteZipcode } from "@core/interfaces/api-responses/autocomplete-zipcode";

@Injectable({
    providedIn: "root",
})
export class UtilService {
    private root = `/api/utils`;
    private readonly rawHttp: HttpClient;

    constructor(
        private httpClient: HttpClient,
        httpBackend: HttpBackend,
    ) {
        this.rawHttp = new HttpClient(httpBackend);
    }

    validateMedicareNumberExists(medicareNumber: string): Observable<{ exists: boolean }> {
        return this.httpClient.request<{ exists: boolean }>("QUERY", `${this.root}/value-exists`, {
            body: { medicareNumber },
        });
    }

    lookupZipCounties(zip: string, year: string): Observable<AutoCompleteZipcode[]> {
        return this.httpClient.get<AutoCompleteZipcode[]>(`${this.root}/autocomplete-zipcode`, {
            params: {
                zip,
                year,
            },
        });
    }

    getMedicareEnrollmentConfig(applicationId?: string | number): Observable<MedicareConfig> {
        return this.httpClient.get<MedicareConfig>(`${this.root}/medicare-config`, {
            ...(applicationId ? { params: { applicationId: String(applicationId) } } : {}),
        });
    }

    getFeatureFlags(): Observable<FeatureFlag> {
        return this.rawHttp.get<FeatureFlag>(`${this.root}/feature-flags`);
    }
}
